import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelephone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTelephone"><Path d="M8.8125 3.5H3.5V5.625C3.5 13.8402 10.1598 20.5 18.375 20.5H20.5V15.1875L16.25 13.0625L14.6562 14.6562C12 13.5938 10.4062 12 9.34375 9.34375L10.9375 7.75L8.8125 3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconTelephone;
